<script>
import { mapActions, mapState } from 'vuex';
import bem from '@/utils/bem';
import { EditTwoTone, PlusCircleOutlined } from '@ant-design/icons-vue';
import KnowAbout from '@/components/ux/knowAbout/Know-About.vue';
import FAQFormModal from '@/components/modals/FAQ-form-modal.vue';

const b = bem('faq-page');

export default {
  components: {
    FAQFormModal,
    KnowAbout,
    PlusCircleOutlined,
    EditTwoTone,
  },
  data() {
    return {
      isShowForm: false,
      isMobile: false,
      isShowActionsForFAQ: false,
      changeableFAQ: {},
      parentChangeableFAQ: {},
    };
  },
  props: {
    currentPage: Object,
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      getFAQByPage: 'faq/getFAQByPage',
      // getTemplatesFAQ: 'faq/getTemplatesFAQ',
    }),
    editFAQ({
      changeableFAQ,
      parentFAQ = this.currentFAQPage,
    }) {
      this.changeableFAQ = changeableFAQ;
      this.parentChangeableFAQ = parentFAQ;
      this.isShowForm = true;
    },
  },
  mounted() {
    if (this.currentPage && this.currentPage.path) {
      this.getFAQByPage({
        path: this.currentPage.path,
      });
    }
    // this.getTemplatesFAQ();
  },
  computed: {
    ...mapState({
      currentFAQPage: (state) => state.faq.faqPage,
      isLoading: (state) => state.faq.isLoading,
    }),
  },
  watch: {
    currentPage: {
      handler(newValue, oldValue) {
        if (newValue.path && newValue.path !== (oldValue || {}).path) {
          this.getFAQByPage({
            path: newValue.path,
          });
        }
      },
      deep: true,
    },
  },
};
</script>

<template>
  <div :class="b()">
    <div :class="b('switch-wrapper')">
      Mobile view:
      <a-switch
        :class="b('switcher')"
        v-model:checked="isMobile"
        :checked="isMobile"
        checked-children="Yes"
        un-checked-children="No"
      />
    </div>
    <div :class="b('switch-wrapper')">
      Show actions for FAQs:
      <a-switch
        :class="b('switcher')"
        v-model:checked="isShowActionsForFAQ"
        :checked="isShowActionsForFAQ"
        checked-children="Yes"
        un-checked-children="No"
      />
    </div>
    <a-spin
      :class="b('spinner')"
      v-if="Boolean(
        (isLoading && !Object.keys(currentFAQPage).length)
        || currentPage.path !== currentFAQPage.page
      )"
      size="large"
    />
    <div
      :class="b('selected-faq', {isMobile})"
      v-else-if='currentFAQPage.id'
    >
      <div :class="b('parent-wrapper', {isMobile})">
        <div :class="b('title', {isMobile})">
          {{isMobile
            ? currentFAQPage.titleMobile || currentFAQPage.title
            : currentFAQPage.title
          }}
          <a-button
            @click="editFAQ({changeableFAQ: currentFAQPage})"
          >
            <EditTwoTone />
          </a-button>
        </div>
        <div :class="b('description', {isMobile})">
          {{isMobile
            ? currentFAQPage.descriptionMobile || currentFAQPage.description
            : currentFAQPage.description
          }}
        </div>
        <a-button
          @click="editFAQ({
            changeableFAQ: { isCategory: true },
            parentFAQ: this.currentFAQPage
          })"
          :class="b('plus-btn-category', {isMobile})"
        >
          Add Category FAQ <PlusCircleOutlined :class="b('plus-category')" />
        </a-button>
      </div>
      <div :class="b('faq-list', {isMobile})">
        <KnowAbout
          v-for="(faq, index) in (currentFAQPage?.faqs || [])"
          :is-mobile="isMobile"
          :faq="faq"
          :key="'faq-' + faq.id"
          :faqs="(currentFAQPage?.faqs || [])"
          :index="index"
          :editFAQ="editFAQ"
          :isShowActionsForFAQ="isShowActionsForFAQ"
        />
        <a-button
          @click="editFAQ({ parentFAQ: this.currentFAQPage })"
          :class="b('plus-btn', {isMobile})"
        >
          Add FAQ <PlusCircleOutlined :class="b('plus')" />
        </a-button>
      </div>
    </div>
    <FAQFormModal
      v-model:show="isShowForm"
      v-model:clearChangeableFAQ="changeableFAQ"
      v-model:clearparentChangeableFAQ="parentChangeableFAQ"
      :changeableFAQ="changeableFAQ"
      :parentChangeableFAQ="parentChangeableFAQ"
    />
  </div>
</template>

<style src="./style.scss" lang="scss"></style>
